import { Card, StoryCard, StoryCardMedia } from "@generalapplications/ui";

import { ResponsiveImage } from "@/app/common/components/composite/media/ResponsiveImage";
import { blogPosts, isPreviewableBlogPost } from "@/content/blog";
import { routes } from "@/app/common/functions/routes/routes";

export type ArticleLinkCardProps = {
  slug: string;
  label?: string;
};

/**
 * An inline link to another article from inside an article body: its
 * picture, title, summary and reading time, for internal cross-linking.
 * Draws the app's link inside the router and a plain one outside it.
 */
export function ArticleLinkCard({
  slug,
  label = "Related Engineering Publication",
}: ArticleLinkCardProps) {
  const post = blogPosts.find(
    (item) => item.slug === slug && isPreviewableBlogPost(item),
  );

  if (!post) return null;

  return (
    <Card radius="xl" padding="md" interactive>
      <StoryCard
        href={routes.blog.detail(post.slug)}
        title={post.title}
        size="sm"
        level={3}
        orientation="horizontal"
        eyebrow={label}
        description={post.summary}
        meta={`${post.readingTime} · Read article`}
      >
        {post.image && (
          <StoryCardMedia>
            <ResponsiveImage
              src={post.image}
              width={600}
              height={315}
              ratio="16:9"
            />
          </StoryCardMedia>
        )}
      </StoryCard>
    </Card>
  );
}
